import React from "react";
import { Route, Switch } from "react-router-dom";
import MainLayout from "./../components/Layout/MainLayout";
import PrivateRoute from "./../components/Auth/PrivateRoute";
import { PortfolioPage } from "./../pages/Portfolio";
import { HistoryPage } from "./../pages/History";
import { Notifications } from "../pages/Notifications";
import { ProfileInfo } from "../pages/ProfileInfo";
import { Authorizations } from "../pages/Authorizations";
import { FutureIncome } from "../pages/FutureIncome";
import { MonthlyStates } from "../pages/MonthlyStates";
import { Orders } from "../pages/Orders";
import { MyData } from "../components/Layout/MyData/MyData";
import { HelpPage } from "../pages/Help";
import { Help } from "../components/Help/Help";
import { InvestPage } from "../pages/Invest";
import { InvestorProfile } from "../components/InvestorProfile/InvestorProfile";
import { ProfileTest } from "../components/ProfileTest/ProfileTest";
import { ProfileTestAnswer } from "../components/ProfileTestAnswer/ProfileTestAnswer";
import { AccountProfileTest } from "../components/Suitability/AccountProfileTest";
import { Redirection } from "../pages/Redirection";
import { RedirectionPayments } from "../pages/RedirectionPayments";
import { InConstruction } from "../components/InConstruction/InConstruction";
import { Onboarding } from "../pages/Onboarding";

import LoginPage from "../pages/Login";
import { Autologin } from "../pages/Autologin";
import IconsPage from "../pages/IconsPage";

export const routes = (
  <Switch>
    <Route path="/login" exact component={LoginPage} />
    <Route path="/autologin" exact component={Autologin} />
    <MainLayout>
      <PrivateRoute path="/" exact component={PortfolioPage} />
      <PrivateRoute path="/history" exact component={HistoryPage} />
      <PrivateRoute path="/orders" exact component={Orders} />
      <PrivateRoute path="/authorizations" exact component={Authorizations} />
      <PrivateRoute path="/futureIncome" exact component={FutureIncome} />
      <PrivateRoute path="/invest" exact component={InvestPage} />
      <PrivateRoute path="/calendar" exact component={MonthlyStates} />
      {/* <PrivateRoute path="/icons" exact component={IconsPage} /> */}
      {/* <PrivateRoute path="/onboarding" exact component={Onboarding} /> */}
      {/* <PrivateRoute path="/notifications" exact component={Notifications} />
      <PrivateRoute path="/documentation" exact component={ProfileInfo} /> */}
      {/* <PrivateRoute path="/myData" exact component={MyData} />
      <PrivateRoute path="/investorProfile" exact component={InvestorProfile} />
      <PrivateRoute path="/investorProfile/profileTest" exact component={ProfileTest} />
      <PrivateRoute path="/investorProfile/profileTestAnswer" exact component={ProfileTestAnswer} />
      <PrivateRoute path="/investorProfile/accountProfileTest" exact component={AccountProfileTest} />
      <PrivateRoute path="/help" exact component={Help} />
      <PrivateRoute path="/Detalles/ConfirmTransaction" exact component={Redirection} />
      <PrivateRoute path="/Detalles/Confirmacion" exact component={RedirectionPayments} /> */}
    </MainLayout>
  </Switch>
);
